export default __webpack_public_path__ + "static/media/warning-white.32187d2e.svg";